import React from 'react';
import tw, { styled } from 'twin.macro';

import { strings } from '../../localization/strings';
import { Coupon } from '../../entities/coupon';
import { currency } from '../../services/formatter/currency';
import { useSite } from '../../hooks/use-site';
import { hasDiscount } from '../../utils/pricing';

const Discount = styled.span`
  ${tw`rounded-full bg-blue-600 border border-white text-xs text-gray-600 py-1.5 px-3`}
`;

interface ProductInfo {
  price?: number | null;
  priceOriginal?: number | null;
}

interface ComponentProps {
  subtotal: number;
  discount?: Coupon;
  total: number;
  showTotal?: boolean;
  product?: ProductInfo;
  isSelfCo?: boolean;
}

function CheckoutTotalsComponent({ subtotal, discount, total, showTotal, product, isSelfCo }: ComponentProps) {
  const { locale, currency: siteCurrency } = useSite();
  const showBlackFridayDiscount = isSelfCo && product && hasDiscount(product);

  return (
    <dl className="text-sm font-medium text-gray-500 mt-10 space-y-6">
      <div className="flex justify-between">
        <dt>{strings().checkout.subTotal}</dt>
        <dd className="text-gray-900">{currency(subtotal, locale, siteCurrency)}</dd>
      </div>
      {!!discount && (
        <div className="flex justify-between">
          <dt className="flex items-center">
            {strings().checkout.discount}
            {discount.amountPercentage && <span>&nbsp;({discount.amountPercentage}%)</span>}
            <Discount className="ml-2">{discount.code}</Discount>
          </dt>
          <dd className="text-gray-900">
            -{currency(discount.amountExact ? discount.amountExact : subtotal - total, locale, siteCurrency)}
          </dd>
        </div>
      )}
      {/*
        <div className="flex justify-between">
          <dt>Taxes</dt>
          <dd className="text-gray-900">{taxes}</dd>
        </div>
        */}
      {showTotal && (
        <div className="flex items-center justify-between border-t font-bold border-gray-200 text-gray-900 pt-6">
          <dt>{strings().checkout.amount}</dt>
          <dd className="text-base flex items-center gap-2">
            {currency(total, locale, siteCurrency)}
            {showBlackFridayDiscount && product?.priceOriginal && (
              <span className="text-red-500 line-through text-sm font-normal">
                {currency(product.priceOriginal, locale, siteCurrency)}
              </span>
            )}
          </dd>
        </div>
      )}
    </dl>
  );
}

CheckoutTotalsComponent.defaultProps = {
  discount: null,
  showTotal: true,
  product: null,
  isSelfCo: false,
};

export default CheckoutTotalsComponent;
